export default __webpack_public_path__ + "media/images/old_logo-contrast-68d5f0feeb08ee93277963871f6377a0.png";